module.exports = __webpack_public_path__ + "static/media/step_2.57db87ec.png";